// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2Y6-_fXDIJc9MFmID2a_v_","reportIssues":"_1_PuDHy-EZFSIjLHJCvSDE","title":"_2GIhiaH6fLS8f8ScTdDPDk","message":"_1ooq5cajsrZYFVCU7_AH-y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportIssue/ReportIssue.scss
// module id = 1772
// module chunks = 0